<template>
	<div id="ad-page">
		<top-link></top-link>

		<div class="part success-list">
			<el-row>
				<el-col :span="6" :offset="0">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_1.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">超轻粘土24色橡皮泥无毒太空水晶彩泥儿童手工diy黏土沙玩具套装</div>
								<div class="content2">静态塑胶玩具/超轻粘土</div>
								<div class="tag-list">
									<div class="tag">零售价：128元 </div>
									<div class="tag">批发价：78元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_2.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">10斤太空玩具沙子套装魔力橡皮彩泥粘土儿童安全无毒男孩女孩散沙</div>
								<div class="content2">天然矿砂 无毒安全 玩沙戏水有“一套”</div>
								<div class="tag-list">
									<div class="tag">零售价：69.90元 </div>
									<div class="tag">批发价：40.50元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_3.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">儿童剪纸折纸手工diy3-4-5-6-7岁制作幼儿园立体宝宝益智趣味玩具</div>
								<div class="content2">色彩鲜艳 优质纸张 安全</div>
								<div class="tag-list">
									<div class="tag">零售价：36.90元 </div>
									<div class="tag">批发价：24元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="0">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_4.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">超轻粘土橡皮泥无毒幼儿彩泥手工黏土大包装diy24色太空儿童玩具</div>
								<div class="content2">加量包装 安全品质 宝宝爱玩</div>
								<div class="tag-list">
									<div class="tag">零售价：78元 </div>
									<div class="tag">批发价：58元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_5.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">沙画儿童彩沙画男孩女孩宝宝手工diy制作益智刮画无毒套装玩具</div>
								<div class="content2">儿童节礼品 优质环保 安全无毒</div>
								<div class="tag-list">
									<div class="tag">零售价：48元 </div>
									<div class="tag">批发价：32元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6" :offset="1">
					<el-card :body-style="{ padding: '0px' }">
						<img src="../../assets/images/shop_goods_6.jpg" class="image">
						<div style="padding: 14px;">
							<div class="bottom clearfix">
								<div class="content1">恐龙化石霸王龙骨架模型儿童手工diy制作挖宝石男孩考古挖掘玩具</div>
								<div class="content2">亲子游戏 培养耐心 探索考古乐趣</div>
								<div class="tag-list">
									<div class="tag">零售价：32元 </div>
									<div class="tag">批发价：22元 </div>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>

	</div>
</template>

<script>
	import TopLink from '../toplink/index.vue'

	export default {
		components: {
			TopLink
		},
		data() {
			return {};
		},
		methods: {
			onClick() {}
		}
	}
</script>

<style lang="scss" scoped>
	#ad-page {

		.success-list {
			margin: 80px auto;
			img {
				width: 356px;
				height: 430px;
			}

			.content1 {
				margin-bottom: 8px;
				font-size: 20px;
				line-height: 28px;
				font-weight: 700;
				color: #313233;
			}

			.content2 {
				margin-bottom: 36px;
				font-size: 16px;
				line-height: 24px;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				overflow: hidden;
				color: #313233;
				-webkit-box-orient: vertical;
				word-break: break-all;
			}


			.el-col {
				margin-top: 30px;
			}

			.bottom {
				height: 130px;

				.tag-list {
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color: #939599;

					.tag {
						display: inline;
						margin-right: 6px;
						padding-right: 6px;
						line-height: 1;
						height: 14px;
						position: relative;

						&::after {
							content: "";
							position: absolute;
							height: 12px;
							width: 1px;
							background: #edeff2;
							right: 0;
							top: 50%;
							-webkit-transform: translate(0, -50%);
							-ms-transform: translate(0, -50%);
							transform: translate(0, -50%);
						}
					}
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/view/ad/index.vue